const STATUS_LABELS = {
  InProgress: "In Progress",
  UnderValidation: "Under Validation",
  Hold: "On Hold",
};

export default function StatusPill({ status }) {
  return (
    <span className={`status-pill status-${status}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
